module.exports = __webpack_public_path__ + "static/media/Age.5b5f0c19.svg";